import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminAddImage.css"; // CSS file for styling
import AdminNavbar from "./AdminNavbar";

function AdminAddImage() {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null
  });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    axios.get("https://himchatterjee.in/backend/getCategories.php")
      .then(res => setCategories(res.data))
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      axios.post(
        "https://himchatterjee.in/backend/getSubcategories.php",
        new URLSearchParams({ id: selectedCategory }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      )
        .then(res => {
          const data = Array.isArray(res.data) ? res.data : [];
          setSubcategories(data);
          if (data.length > 0) setSelectedSubcategory(data[0].id);
        })
        .catch(err => console.log(err));
    } else {
      setSubcategories([]);
      setSelectedSubcategory("");
    }
  }, [selectedCategory]);

  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCategory || !selectedSubcategory) {
      setMsg("Please select category and subcategory");
      return;
    }

    const data = new FormData();
    data.append("category", selectedCategory);
    data.append("subcategory", selectedSubcategory);
    data.append("title", formData.title);
    data.append("description", formData.description);
    data.append("image", formData.image);

    axios.post("https://himchatterjee.in/backend/upload_image.php", data)
      .then(res => setMsg(res.data.msg))
      .catch(err => setMsg("Upload failed"));
  };

  return (
    <>
    <AdminNavbar />
    <div className="admin-add-image-container">
    
      <h2 className="form-title">Add New Artwork</h2>
      {msg && <div className="message">{msg}</div>}

      <form onSubmit={handleSubmit} className="admin-form">

        <div className="form-group">
          <label>Category:</label>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            required
          >
            <option value="">-- Select Category --</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Sub-Category:</label>
          <select
            value={selectedSubcategory}
            onChange={(e) => setSelectedSubcategory(e.target.value)}
            disabled={!selectedCategory}
            required
          >
            {selectedCategory ? (
              subcategories.map(sub => (
                <option key={sub.id} value={sub.id}>{sub.name}</option>
              ))
            ) : (
              <option>Select a category first</option>
            )}
          </select>
        </div>

        <div className="form-group">
          <label>Title:</label>
          <input
            type="text"
            value={formData.title}
            onChange={e => setFormData({ ...formData, title: e.target.value })}
            placeholder="Enter artwork title"
            required
          />
        </div>

        <div className="form-group">
          <label>Description:</label>
          <textarea
            value={formData.description}
            onChange={e => setFormData({ ...formData, description: e.target.value })}
            placeholder="Enter a brief description"
            required
          />
        </div>

        <div className="form-group">
          <label>Upload Image (JPG only):</label>
          <input type="file" accept=".jpg" onChange={handleFileChange} required />
          <small className="note">Only JPG files are allowed. Max size 5MB.</small>
        </div>

        <button type="submit" className="submit-btn">Upload Artwork</button>
      </form>
    </div>
    </>
  );
}

export default AdminAddImage;
